<template>
  <div :id="id" :class="className" :style="{height:height,width:width}" />
</template>
<script>
import echarts from 'echarts';
import resize from './mixins/resize';

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    id: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    chartData: {
      type: Object
    }
  },
  data() {
    return {
      chart: null,
      options: {
        backgroundColor: 'rgba(128, 128, 128,0)',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            textStyle: {
              color: '#fff'
            }
          }
        },
        legend: {
          show: true,
          orient: 'horizontal',
          x: 'center',
          y: 'bottom',
          data: ['种植面积', '结果面积'],
          itemWidth: 10,
          itemHeight: 5,
          textStyle: {
            color: '#fff',
            fontSize: '12'
          }
        },
        grid: {
          top: '15%',
          borderWidth: 0,
          bottom: '40%',
          left: '13%',
          textStyle: {
            color: '#fff'
          }
        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            axisLine: {
              lineStyle: {
                color: 'rgba(255,255,255,.5)'
              }
            },
            axisLabel: {
              show: true,
              margin: '10',
              fontSize: '8',
              rotate: 45,
              textStyle: {
                color: '#ffffff' //X轴文字颜色
              }
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitArea: {
              show: false
            },
            data: []
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '单位:亩',
            nameTextStyle: {
              color: '#339FFB',
              fontSize: 8,
              show: true,
              lineHeight: 0
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: '#1B2F44'
              }
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#ffffff'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0,
              color: '#AEB7C0',
              fontSize: 12
            },
            splitArea: {
              show: false
            }
          }
        ],
        series: [
          {
            name: '结果面积',
            type: 'bar',
            stack: '总量',
            barMaxWidth: 35,
            barGap: '10%',
            itemStyle: {
              normal: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 1,
                      color: 'rgba(255, 216, 36, 1)' // 0% 处的颜色
                    },
                    {
                      offset: 0,
                      color: 'rgba(255, 146, 18, 1)' // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              }
            },
            data: []
          },
          {
            name: '种植面积',
            type: 'line',
            symbolSize: 10,
            symbol: 'circle',
            itemStyle: {
              normal: {
                color: '#0FA395',
                barBorderRadius: 0,
                lineStyle: {
                  normal: {
                    width: 4,
                    color: '#0FA395'
                  }
                }
              }
            },
            data: []
          }
        ]
      }
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setData();
      }
    }
  },
  mounted() {
    this.initChart();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    setData() {
      this.options.xAxis[0].data = this.chartData.regionName;
      this.options.series[0].data = this.chartData.plantArea;
      this.options.series[1].data = this.chartData.actualArea;
      this.chart.setOption(this.options);
    },
    initChart() {
      if (!this.chart) {
        this.chart = echarts.init(document.getElementById(this.id));
      }

      this.setData();
    }
  }
};
</script>